import { isPcClient, getCookie, setCookie, addEvent, removeEvent, getServer, getAPI } from '@/assets/js/tools';
import router from "../../router";
import store from "../../store";
// import { servers } from "./tools";

const helper = {
  install(Vue, options) {
    Vue.prototype.emptyImg = getServer() + '/common/images/kong-mba.png';
    Vue.prototype.inPc = isPcClient;
    Vue.prototype.getServer = getServer;
    Vue.prototype.getAPI = getAPI;

    Vue.prototype.storage = {
      set: (key, value, ttl = 0) => {
        const now = new Date().getTime();
        const item = { value: value, exp: ttl ? now + ttl : 0 };
        localStorage.setItem(key, JSON.stringify(item));
      },
      get: (key) => {
        const item = JSON.parse(localStorage.getItem(key));
        if (!item) return null;
        const now = new Date().getTime();
        if (item.exp && now > item.exp) {
          localStorage.removeItem(key);
          return null;
        }
        return item.value;
      },
      remove: (key) => {
        localStorage.removeItem(key);
      },
      getExpirationTime: (key) => {
        const item = JSON.parse(localStorage.getItem(key));
        if (!item) return null;
        return item.exp;
      }
    };
    Vue.directive('flex-top', {
      bind: function (el) {
        if (!el.parentNode) {
          setTimeout(() => {
            const parentTop = el.parentNode.offsetTop;
            el.style.top = `${parentTop}px`;
          }, 0);
        } else {
          const parentTop = el.parentNode.offsetTop;
          el.style.top = `${parentTop}px`;
        }
      },
      update: function (el) {
        if (!el.parentNode) {
          setTimeout(() => {
            const parentTop = el.parentNode.offsetTop;
            el.style.top = `${parentTop}px`;
          }, 0);
        } else {
          const parentTop = el.parentNode.offsetTop;
          el.style.top = `${parentTop}px`;
        }
      }
    });
    Vue.directive('default-avatar', {
      bind: function (el) {
        const user = store.state.user;
        let errorURL;

        if (user) {
          const gender = user.user_sex === 1 ? 'man' : 'woman';
          errorURL = `${getServer()}/img/img_head_default_${gender}.png`;
        } else {
          errorURL = `${getServer()}/img/img_head_default_wsz.png`;
        }

        if (!el.src) {
          el.src = errorURL;
          return
        }

        el.onerror = function () {
          el.src = errorURL;
        }
      }
    })

    function caculateHeight(data) {
      let el = data.el;
      let binding = data.binding;

      let from = binding.arg;
      el.style["min-height"] = document.documentElement.clientHeight + "px";
    }

    Vue.directive("page-height", {
      bind(el, binding) {
        addEvent(window, "resize", caculateHeight, {el: el, binding: binding});
        caculateHeight({el: el, binding: binding});
      },
      unbind() {
        removeEvent(window, "resize", caculateHeight);
      }
    });

    Vue.prototype.urlMerge = function (obj) {
      let query = JSON.parse(JSON.stringify(router.currentRoute.query));
      Object.assign(query, obj);
      router.replace({ query: query });
    };

    function getCurrentDomain() {
      var parts = window.location.hostname.split('.');
      var domain = parts.slice(-2).join('.');
      return '.' + domain;
    }

    Vue.prototype.logOut = function (obj) {
      var dynamicDomain  = getCurrentDomain();

      this.$cookies.remove('ai_session', '/', dynamicDomain );
      this.$cookies.remove('aiAccessToken', '/', dynamicDomain );
      this.$cookies.remove('aiLoginToken', '/', dynamicDomain );
      this.$cookies.remove('aiUserName', '/', dynamicDomain );
      this.$cookies.remove('aiWeixinLoginToken', '/', dynamicDomain );
      localStorage.removeItem('aiAccessToken');
      localStorage.removeItem('aiLoginToken');
      localStorage.removeItem('aiWeixinLoginToken');
      store.commit("setToken", null);
      store.commit("setLoginToken", null);
      store.commit("setWeixinLoginToken", null);

      this.unLoginHandle();
    };
    Vue.prototype.unLoginHandle = function (num) {
      // 清空用户数据
      store.commit('set_user', null)
      store.commit('setDistribution', null)

      if (this.inPc && router.currentRoute.meta.pc) {
        // pc改用弹窗登录
        store.commit('setBounceLodin', true)
        return false;
      }

      //非login页面，跳转到login
      if (!location.href.includes('/login')) {
        // 复制需要序列化的属性到新对象
        const serializedObj = {
          name: router.currentRoute.name,
          path: router.currentRoute.path,
          params: { ...router.currentRoute.params },
          query: { ...router.currentRoute.query },
          meta: { ...router.currentRoute.meta },
        };
        // 保存当前路由信息到 Vuex 中
        store.commit('setCurrentRoute', router.currentRoute)
        this.storage.set('currentRoute', JSON.stringify(serializedObj));

        router.push({ path: '/login' });
      }
    };
    Vue.prototype.isToken = function () {
      let accessToken = this.$cookies.get('aiAccessToken');
      let loginToken = this.$cookies.get('aiLoginToken');
      let WeixinLoginToken = this.$cookies.get('aiWeixinLoginToken');
      let localWeixinLoginToken = localStorage.getItem('aiWeixinLoginToken');

      if (WeixinLoginToken) {
        localStorage.setItem('aiWeixinLoginToken', WeixinLoginToken);
        store.commit("setWeixinLoginToken", WeixinLoginToken);
      } else if (localWeixinLoginToken) {
        // setCookie('aiWeixinLoginToken', localWeixinLoginToken, 60 * 24 * 30, '.chaodanfan.com');
        this.$cookies.set("aiWeixinLoginToken", localWeixinLoginToken, 60 * 60 * 24 * 30);
        store.commit("setWeixinLoginToken", localWeixinLoginToken);
      }

      if (loginToken) {
        //设置全局token
        localStorage.setItem('aiAccessToken', accessToken);
        localStorage.setItem('aiLoginToken', loginToken);
        store.commit("setToken", accessToken);
        store.commit("setLoginToken", loginToken);
      } else {
        localStorage.removeItem("token")
      }
    };
    Vue.prototype.updateUserInfo = function (needToken) {
      const qsData = {
        access_token: store.state.token,
        needToken: needToken,
      }
      return this.$axios.get('/user/getuserinfo', { params: qsData }).then(res => {
        if (!res) return;
        let result = res.data;
        if (result.errorno) {
          store.commit("set_user", null);
          return false
        };
        store.commit("set_user", result);
      }).catch(err => {
        // console.log(err);
      })
    };
    Vue.prototype.updateDistributionInfo = function (needToken) {
      const qsData = {
        access_token: store.state.token,
        needToken: needToken,
      }
      return this.$axios.get('/distribution/info', { params: qsData }).then(res => {
        if (!res) return;
        let result = res.data;
        if (result.errorno) {
          store.commit("setDistribution", null);
          return false
        };
        store.commit("setDistribution", result.info);
      }).catch(err => {
        // console.log(err);
      })
    };
    Vue.prototype.TimeOrdering = function () {
      let key = router.currentRoute.query.key;
      let chatList = (this.storage.get("historyChatList") || {})[store.state.user.user_name];

      if (key && chatList) {
        chatList.forEach((ele) => {
          if (ele.key == key) {
            ele.time = new Date();
          }
        });
        store.commit("sethistoryChatList", chatList);
      }
    };
    Vue.prototype.setImgUrl = function (trailingEnd) {
      let url = '/chat/static/img/' + store.state.motif + trailingEnd;

      return url;
    }
  }
}

export default helper



// WEBPACK FOOTER //
// ./src/assets/js/base.js